"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnumerable = void 0;
exports.isEnumerable = (object, prop) => Object.prototype.propertyIsEnumerable.call(object, prop);
//# sourceMappingURL=is-enumerable.js.map